import React, { useEffect, useMemo, useState } from "react";
import Card from "../../../components/common/Card";
import Paper from "@mui/material/Paper";
import DateRangePickerComponent from "../../../components/common/DateRangePickerComponent";
import "./viewMaintenance.css";
import ReactMuiTable from "../../../components/common/ReusableTable/ReactTable";
import ColumnFilter from "../../../components/common/ColumnFilter";
import {
  getShiftDetails1,
  getSiteDetails,
  vehicleTypes,
  viewFuelDetails,
  viewTripDetails,
} from "../../../services/vehicleService";
import { useFormik } from "formik";
import { withErrorHandler } from "../../../utils/tryCatchHandler";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../redux/features/authSliceandSidebar";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
  TextField,
  Menu,
} from "@mui/material";
import ConfimationModal from "../../../components/modals/ConfirmationModal";
import { viewMaintenance } from "../../../services/maintenanceService";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const TrackMaintenance = () => {
  const [activeTab, setActiveTab] = useState("permanent");
  const [searchQuery, setSearchQuery] = useState("");
  // const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [selectedRadio, setSelectedRadio] = useState("active");
  let today = new Date();
  let yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const navigate = useNavigate();

  const [detailObj, setDetailObj] = useState(null);
  const [previousDate, setPreviousDate] = useState(new Date());
  const [dateRange, setDateRange] = useState([
    {
      startDate: yesterday,
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [selectedRow, setSelectedRow] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const editDetail = (selectedRow) => {
    // console.log(cell.row.original);
    setDetailObj(selectedRow);
    // formik1.setValues(selectedRow);
    // formik1.setFieldValue("id", selectedRow?.tripId);
    // setShowModal2(true);
    localStorage.setItem("detailsObj", JSON.stringify(selectedRow));
    navigate("/editMaintenance");
    // EditVendorDetailsApi(selectedRow);
  };
  const handleEdit = () => {
    console.log("Edit", selectedRow);

    if (!(selectedRow.outComment || selectedRow.outDate)) {
      editDetail(selectedRow);
    } else {
      handleClose();
      toast.warn("Vehicle is out of Maintenance");
    }
    handleClose();
  };

  const [showModal1, setShowModal1] = useState(false);
  const [formData, setFormData] = useState({
    employeeType: "permanent",
    department: "",
    employeeId: "",
    fullName: "",
    contact: "",
    email: "",
  });

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [activeId, setActiveId] = useState(0);
  const isLogin = useSelector((x) => x.authSliceandSidebar.isLogin);
  const dispatch = useDispatch();
  const [tripData, setTripData] = useState([]);
  const [key, setKey] = useState(Math.random());

  const [vehicleList, setVehicleList] = useState([]);
  const [sitesList, setSitesLsit] = useState([]);
  const [shiftList, setShiftList] = useState([]);

  const fullData = [
    { firstName: "Alice", lastName: "Johnson" },
    { firstName: "Bob", lastName: "Smith" },
    { firstName: "Charlie", lastName: "Brown" },
    { firstName: "David", lastName: "White" },
    { firstName: "Emma", lastName: "Black" },
    { firstName: "Fiona", lastName: "Green" },
    { firstName: "George", lastName: "Red" },
    { firstName: "Helen", lastName: "Blue" },
  ];

  const rawColumns = [
    { Header: "Id", accessor: "id" },
    { Header: "Name", accessor: "vehicleName" },
    {
      Header: "Vehicle No.",
      accessor: "vehicleNumber",
      Cell: (cell) => {
        return (
          <>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedRow(null);
                handleMenuClick(e, cell.row.original);
              }}
            >
              {" "}
              {cell.row.original.vehicleNumber}{" "}
            </a>
          </>
        );
      },
    },
    { Header: "Vendor Name", accessor: "vendorName" },
    { Header: "Hour Reading", accessor: "hourReading" },
    { Header: "Remarks", accessor: "inComment" },
    { Header: "Maintenance Type", accessor: "maintenanceType" },

    { Header: "Created By", accessor: "createdBy" },
    // {
    //   Header: "View",
    //   Footer: "User-Action",
    //   accessor: "action",
    //   Cell: (cell) => {
    //     return (
    //       <>
    //         <IconButton
    //           title="View Detail"
    //           style={{ marginLeft: "19%" }}
    //           onClick={() => {
    //             viewDetail(cell);
    //           }}
    //         >
    //           <VisibilityIcon style={{ color: "blue", fontSize: "19px" }} />
    //         </IconButton>
    //       </>
    //     );
    //   },
    //   disableFilters: true,
    // },

    {
      Header: "Actions",
      Footer: "User-Action",
      accessor: "actio1n",
      Cell: (cell) => {
        return (
          <>
            <IconButton
              title={"Actions "}
              onClick={(e) => {
                setSelectedRow(null);
                handleMenuClick(e, cell.row.original);
              }}
            >
              <MoreVertIcon />
            </IconButton>
          </>
        );
      },
      disableFilters: true,
    },
  ];

  const columns = React.useMemo(() => {
    return rawColumns;
  }, []);

  function toNormalCase(key) {
    return key
      ?.replace(/([A-Z])/g, " $1")
      ?.replace(/^./, (str) => str.toUpperCase()) // capitalize first letter
      .trim(); // remove any leading space
  }

  const viewDetail = () => {
    // console.log(cell.row.original);
    setDetailObj(selectedRow);
    setShowModal1(true);
    handleClose();
  };

  const paginatedData = React.useMemo(() => {
    const start = pageIndex * pageSize;
    return tripData?.slice(start, start + pageSize);
  }, [pageIndex, pageSize, tripData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (isLogin) {
      setKey(Math.random());
      dispatch(setLoader(true));
      getVehiclees();
      getSites();
      getShiftDetails();
    }
  }, [isLogin]);

  const getSites = async () => {
    setSitesLsit([]);
    withErrorHandler(
      await getSiteDetails().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          // console.log(res.data);
          setSitesLsit(res.data.siteDetails);
          formik.setFieldValue(
            "tripDate",
            moment(new Date()).format("YYYY-MM-DD")
          );
          formik.setFieldValue("siteIdState", res.data.siteDetails[0]);
          formik.setFieldValue("siteId", res.data.siteDetails[0].siteId);
        } else if (res && res.data.statusDescription?.statusCode == 401) {
          dispatch(setLoader(false));
        }
      })
    );
  };

  const getShiftDetails = async () => {
    setShiftList([]);
    withErrorHandler(
      await getShiftDetails1().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setShiftList(res.data.shiftDetails);
          formik.setFieldValue("shiftId", res.data.shiftDetails[0].shiftId);

          formik.setFieldValue("shiftName", res.data.shiftDetails[0].name);
          dispatch(setLoader(false));
          // setSelectedRadio(res.data.shiftDetails[0].shiftId);
        } else {
        }
      })
    );
  };

  const getVehiclees = async () => {
    setVehicleList([]);
    withErrorHandler(
      await vehicleTypes().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setVehicleList(res.data.data);

          if (localStorage.getItem("vehicleName") != null) {
            setActiveTab(localStorage.getItem("vehicleName"));
            // setActiveId(localStorage.getItem("vehicleTypeId"));
            formik.setFieldValue(
              "vehicleTypeId",
              localStorage.getItem("vehicleTypeId")
            );
            formik.setFieldValue(
              "vehicleName",
              localStorage.getItem("vehicleName")
            );
          } else {
            setActiveTab(res.data.data[0].name);
            setActiveId(res.data.data[0].vehicleTypeId);
            formik.setFieldValue(
              "vehicleTypeId",
              res.data.data[0].vehicleTypeId
            );
            formik.setFieldValue("vehicleName", res.data.data[0].name);
          }
        } else {
        }
        // setSelectedRadio(res.data.shiftDetails[0].shiftId);
      })
    );
  };

  const formik = useFormik({
    initialValues: {
      siteId: null,
      shiftId: null,
      tripDate: null,
      siteIdState: null,
      tripDateState: new Date(),
      vehicleTypeId: null,
      vehicleName: "",
      shiftName: "",
      startDate: null,
      endDate: null,
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      dispatch(setLoader(true));
      // console.log(values);
      setTripData([]);

      let formdata = { ...values };
      //   delete formdata["siteIdState"];
      //   setKey(Math.random());
      //   delete formdata["tripDate"];
      formdata["startDate"] = formik.values.tripDate;
      formdata["endDate"] = formik.values.tripDate;
      await viewMaintenance(formdata).then((res) => {
        dispatch(setLoader(false));
        if (res && res?.data?.statusDescription?.statusCode == 200) {
          console.log(res.data);
          setTripData(res.data.maintenanceDetailLogL1List);
          dispatch(setLoader(false));
          setKey(Math.random());
        }
      });
    },
  });
  useEffect(() => {
    if (
      formik.values.shiftId &&
      formik.values.siteId &&
      dateRange &&
      formik.values.vehicleTypeId
    ) {
      setKey(Math.random());
      document.getElementById("go_for_hit1")?.click();
      //   let e;

      //   formik.handleSubmit(e);
    }
  }, [
    formik.values.vehicleTypeId,
    // formik.values.shiftId,
    // formik.values.siteId,
    // dateRange,
  ]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form submitted:", formData);
  };

  return (
    <div className="staff-management">
      <div className="tabs-container mb-3 tb_colored">
        {vehicleList?.map((x, i) => {
          return (
            <>
              <button
                key={i}
                className={`tab ${activeTab === x.name ? "active" : ""}`}
                onClick={(e) => {
                  setActiveTab(x.name);
                  // setVehicleVendorList([]);

                  // formik.handleReset(e);
                  formik.setFieldValue("vehicleTypeId", x.vehicleTypeId);
                  formik.setFieldValue("vehicleName", x.name);
                }}
              >
                {x.name}
              </button>
            </>
          );
        })}
      </div>

      <div className="row mx-2 px-1 controls-container">
        <div className="col-md-2 col-12 site_div">
          <FormControl sx={{ padding: "2px" }} fullWidth>
            <InputLabel shrink={true}>
              Site <span className="text text-danger">* </span>
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={formik.values.siteIdState}
              required
              size="small"
              name="siteIdState"
              label="Projects"
              onChange={(e) => {
                formik.handleChange(e);
                // console.log(e.target.value);
                formik.setFieldValue("siteId", e.target.value.siteId);
              }}
              MenuProps={{
                disableAutoFocusItem: true, // Prevents auto-focusing the first item
                disableEnforceFocus: true, // Prevents focus trapping
                disableRestoreFocus: true, // Prevents restoring focus to input
              }}
            >
              <MenuItem value={0} style={{ fontSize: "12px" }}>
                {" "}
                Select Site
              </MenuItem>
              {sitesList.length > 0 &&
                sitesList.map((data) => {
                  return (
                    <MenuItem
                      key={data.siteId}
                      value={data}
                      style={{ fontSize: "11px" }}
                    >
                      {" "}
                      {data.siteName}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </div>
        <div className="radio-group col-md-4 col-12">
          {shiftList?.map((x, i) => {
            return (
              <>
                <label key={i}>
                  <input
                    type="radio"
                    name="status"
                    value={
                      formik.values.shiftId == x.shiftId ? "active" : "inactive"
                    }
                    checked={formik.values.shiftId == x.shiftId}
                    onChange={(e) => {
                      // setSelectedRadio(x.shiftId);
                      formik.setFieldValue("shiftId", x.shiftId);
                    }}
                  />
                  {x.name}
                </label>
              </>
            );
          })}
        </div>

        <div className="date-picker col-md-3 col-12">
          <div className="date-picker">
            <input
              type="date"
              name="tripDate"
              value={formik.values.tripDate}
              onChange={(e) => {
                // console.log(e);
                formik.handleChange(e);
              }}
            />
          </div>
        </div>
        <div className="col-md-1 col-12 yellow_apply">
          <button
            className="btn yellow_btn_1"
            type="button"
            id="go_for_hit1"
            onClick={(e) => {
              // console.log("submittrf");
              formik.handleSubmit(e);
              setKey(Math.random());
            }}
          >
            {" "}
            Apply <i className="fa fa-left-arrow"></i>{" "}
          </button>
          {isMobile && (
            <button
              className="btn btn-primary mx-1  p-0  yellow_btn_2"
              type="button"
              onClick={(e) => {
                localStorage.setItem(
                  "vehicleTypeId",
                  formik.values.vehicleTypeId
                );
                localStorage.setItem("vehicleName", formik.values.vehicleName);
                navigate("/addToMaintenance");
              }}
            >
              Add
            </button>
          )}
        </div>
      </div>

      <Card
        title={`${
          activeTab.charAt(0).toUpperCase() + activeTab.slice(1)
        } Fuel Management`}
      >
        <form onSubmit={handleSubmit}>
          {/* <div className="container-fluid main_container"> */}
          <div className="form-row group_div">
            <Paper style={{ width: "100%" }}>
              {tripData?.length > 0 ? (
                <ReactMuiTable
                  columns={columns}
                  data={paginatedData}
                  pageIndex={pageIndex}
                  pageSize={pageSize}
                  key={key}
                  totalCount={tripData.length}
                  onPageChange={(newPage) => {
                    setKey(Math.random());
                    setPageIndex(newPage);
                  }}
                  onPageSizeChange={(newSize) => {
                    setKey(Math.random());
                    setPageSize(newSize);
                    setPageIndex(0);
                  }}
                />
              ) : (
                <div className="d-block text-center px-5  py-5">
                  <h4>No record found</h4>
                </div>
              )}
            </Paper>
          </div>
        </form>

        <ConfimationModal
          show={showModal1}
          onHide={() => setShowModal1(false)}
          size="xl"
          onSubmit={() => {
            setShowModal1(false);
          }}
          title={
            "View Details" +
            " > " +
            detailObj?.siteName +
            " > " +
            detailObj?.vehicleName +
            " > " +
            detailObj?.vehicleNumber
          }
          hideSubmit={true}
        >
          <div className="container">
            <div className="row">
              {detailObj &&
                Object.keys(detailObj).map((x) => {
                  if (!x.includes("attachmen")) {
                    return (
                      <>
                        {detailObj[x] && !x.includes("Id") ? (
                          <div className="col-md-3 mt-2">
                            {/* {toNormalCase(x)} */}
                            <TextField
                              value={
                                toNormalCase(x).split("")[1] == "At" ||
                                x.toLowerCase().includes("tripdate") ||
                                x.toLowerCase().includes("createdat")
                                  ? moment(detailObj[x]).format("DD-MM-YYYY") +
                                    ` ${detailObj[x].split(" ")[1]}`
                                  : detailObj[x]
                              }
                              label={x ? toNormalCase(x) : ""}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  } else {
                    return (
                      <>
                        {detailObj[x] && x.includes("attachmen") ? (
                          <div className="col-md-3 mt-2">
                            <label> Attachments </label>

                            <ul>
                              {detailObj[x]?.map((y) => {
                                return (
                                  <li>
                                    <a
                                      target="_blank"
                                      href={y.url}
                                      className="attachment_text"
                                    >
                                      {y.saveFileName}
                                    </a>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  }
                })}
            </div>
          </div>
        </ConfimationModal>

        {anchorEl && (
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={viewDetail}>View Breakdown </MenuItem>
            <MenuItem onClick={handleEdit}>Update Breakdown</MenuItem>
            {/* <MenuItem onClick={handleDelete}>Delete</MenuItem> */}
          </Menu>
        )}
      </Card>
    </div>
  );
};

export default TrackMaintenance;
